import React, { useContext, useEffect, useState } from 'react';
import { AccountContext } from '../../../../components/AccountContext';
import { NotificationContext } from '../../../../components/GrowlNotifications';
import { defineMessages, useIntl } from 'react-intl';
import { useQuery } from '@apollo/react-hooks';
import { SUPER_MATCH_LIST_QUERY } from '../../services/super-match.service';
import { Loading } from '../../../../components/Loading';
import { growlErrors } from '../../../../utils/NotificationUtil';
import { Panel } from 'primereact/panel';
import NoSuperMatches from '../../components/list/NoSuperMatches';
import SuperMatchesListHeader from '../../components/list/SuperMatchesListHeader';
import SuperMatchesList from '../../components/list/SuperMatchesList';
import SuperMatchContactRequestDialog from '../../components/list/SuperMatchContactRequestDialog';

const i18nMessages = defineMessages({
  superMatches: {
    id: 'account.super-matches',
    defaultMessage: 'SuperMatches',
  },
});

const SuperMatches = () => {
  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);
  const { formatMessage } = useIntl();

  const [superMatchToRequestContactFor, setSuperMatchToRequestContactFor] = useState(null);
  const [superMatches, setsuperMatches] = useState([]);

  const { loading, error, data } = useQuery(SUPER_MATCH_LIST_QUERY, {
    variables: {
      accountId: currentAccount,
    },
    fetchPolicy: 'no-cache',
  });

  const { account } = data;

  useEffect(() => {
    if (account) {
      setsuperMatches(account.superMatches);
    }
    // eslint-disable-next-line
  }, [account]);

  if (loading) {
    return <Loading />;
  }

  if (error) {
    growlErrors(growl, error);
  }

  if (superMatches.length === 0) {
    return <NoSuperMatches />;
  }

  return (
    <div className="p-grid">
      <div className="p-col-12">
        <div className="brand-detailed-wrapper">
          <SuperMatchContactRequestDialog
            superMatchId={superMatchToRequestContactFor}
            hide={() => setSuperMatchToRequestContactFor(null)}
          />
          <Panel header={formatMessage(i18nMessages.superMatches)}>
            <SuperMatchesListHeader />
            <SuperMatchesList
              superMatches={superMatches}
              requestContact={(superMatchId) => setSuperMatchToRequestContactFor(superMatchId)}
            />
          </Panel>
        </div>
      </div>
    </div>
  );
};

export default SuperMatches;
